<template>
  <section class="auth-change-password">
    <v-card class="mx-auto pa-6 text-center change-password fill-width">
      <ChangePassword>
        <template #title>
          <h2 class="text-capitalize text-h5 text--secondary my-5 text-center">
            {{ $t("auth.changePassword.title") }}
          </h2>
        </template>

        <template #back>
          <v-row justify="start" class="mt-4">
            <v-btn
              text
              color="primary"
              class="text-capitalize"
              :to="{ name: 'loginForm' }"
            >
              <v-icon
                size="20"
                :color="$vuetify.theme.themes.light.primary"
                :class="['me-2', { 'icon-rotation': $vuetify.rtl }]"
              >
                mdi-arrow-left-thin
              </v-icon>

              <span class="font-medium-14">
                {{ $t("auth.changePassword.backButton") }}
              </span>
            </v-btn>
          </v-row>
        </template>
      </ChangePassword>
    </v-card>
  </section>
</template>
<script>
import ChangePassword from "@/components/Common/ChangePassword";

export default {
  name: "auth-change-password",
  components: { ChangePassword },
  mounted() {
    // if (!localStorage.getItem("access_token")) {
    //   this.$router.replace({ name: "loginForm" });
    // }
  }
};
</script>
<style scoped lang="scss">
@import "ChangePassword";
</style>
